export default __webpack_public_path__ + "static/my-icon-brain-cd685f5053633113d7c53eb47171f64f.png";